import { Menu, X } from 'lucide-react';
import { useState } from 'react';

interface HeaderProps {
  currentPage: string;
  onNavigate: (page: string) => void;
}

export function Header({ currentPage, onNavigate }: HeaderProps) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navItems = [
    'Home',
    'About Us',
    'Product',
    'News',
    'Knowledge',
    'Manual download',
    'Contact Us'
  ];

  return (
    <header className="bg-white shadow-md sticky top-0 z-50" role="banner">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center">
            <button
              onClick={() => onNavigate('Home')}
              className="hover:opacity-80 transition-opacity"
              aria-label="SHANGHAI DAOCHIN MECHANICAL EQUIPMENT CO., LTD. (DCH) - Back to Home"
            >
              <img 
                src="/image.png" 
                alt="DAOCHIN MECHANICAL Logo" 
                className="h-12 w-auto"
              />
            </button>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8" aria-label="Main Navigation">
            {navItems.map((item) => (
              <button
                key={item}
                onClick={() => onNavigate(item)}
                className={`transition-colors hover:text-primary ${
                  currentPage === item
                    ? 'text-primary font-semibold'
                    : 'text-gray-700'
                }`}
                aria-current={currentPage === item ? 'page' : undefined}
              >
                {item}
              </button>
            ))}
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2 rounded-md hover:bg-gray-100"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={mobileMenuOpen}
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <nav className="lg:hidden py-4 border-t" aria-label="Mobile Navigation">
            {navItems.map((item) => (
              <button
                key={item}
                onClick={() => {
                  onNavigate(item);
                  setMobileMenuOpen(false);
                }}
                className={`block w-full text-left px-4 py-3 transition-colors hover:bg-gray-50 ${
                  currentPage === item
                    ? 'text-primary font-semibold bg-primary/10'
                    : 'text-gray-700'
                }`}
                aria-current={currentPage === item ? 'page' : undefined}
              >
                {item}
              </button>
            ))}
          </nav>
        )}
      </div>
    </header>
  );
}
